import { getCMSInterceptors } from '@getjust/cms-interceptors';
import { useMemo } from 'react';

import type { CheckoutV1 } from '@getjust/api-schema';
import type { InterceptorInterface } from '@getjust/cms-interceptors';
import type { Cart } from '@getjust/gateway';

import { useShop } from '../queries';

// Default functions
const redirectToOrderPage = (options: { cart?: Cart; order: CheckoutV1.OrdersGetStatusResponseBody }) => {
  if (options?.order?.outcome === 'ready') {
    window.location.href = options?.order?.url;
  }
};

export const useCMSInterceptors = (): InterceptorInterface => {
  const { data: shop } = useShop();
  const cmsHooks = useMemo(() => {
    if (!shop) {
      return {};
    }
    return getCMSInterceptors(shop?.platformType);
  }, [shop]);

  return {
    redirectToOrderPage,
    ...cmsHooks,
  };
};
